export const TYPE = {
  balance_maintenance: 'Manutenção de saldo',
  service_charge: 'Realização de serviço',
  service_refund: 'Reembolso de serviço',
}

export const SCOPE = {
  Castration: 'Castração',
}
